import Init from './classes/Init';
import Util from './classes/Util';

import './lib/propForms';
import './lib/slick';
import './lib/lazysizes';

import Cookies from 'js-cookie';
import Flickity from 'flickity-bg-lazyload';

(function (window) {

    const propFuncs = {

        lazySizes__ready: function () {

            document.addEventListener('lazybeforeunveil', (e) => {
                let bg = e.target.getAttribute('data-bg');
                if (bg) {
                    e.target.style.backgroundImage = 'url(' + bg + ')';
                }
            });

        },

        lazyload__ready: function () {

            window.lazySizesConfig = window.lazySizesConfig || {};

            window.lazySizesConfig.lazyClass = 'js-img';

            lazySizesConfig.loadMode = 1;

        },

        forms__ready() {

            window.slick = new slickForms({

                select: true,
                checkbox: true,
                radio: true,
                file: true

            });

            $('.js-form').propForm({
                ajax: true
            });

        },

        header__ready() {

            // $('.js-subnav-trigger') == document.querySelectorAll('.js-subnav-trigger');
            let subnavTrigger = document.querySelector('.js-subnav-trigger'),
                subnav = document.querySelector('.js-subnav'),
                searchTrigger = document.querySelector('.js-search-trigger'),
                search = document.querySelector('.js-search'),
                searchInput = document.querySelector('.js-search-input');

            subnavTrigger && Util.addEventListener(subnavTrigger, ['click', 'mouseover'], (e) => {
                e.preventDefault();

                Util.toggleClass(subnavTrigger, 'is-active');
                Util.toggleClass(subnav, 'is-active');

                /*if( Util.hasClass(subnavTrigger, 'is-active')){
                    subnavTrigger.innerHTML = 'Close &times;';
                } else {
                    subnavTrigger.innerHTML = 'Grand Classics';
                }*/
            });

            searchTrigger && Util.addEventListener(searchTrigger, ['click'], (e) => {
                e.preventDefault();

                Util.toggleClass(search, 'is-active');

                searchInput.focus();
            });

        },

        sliderPromo__ready() {
            const slider = document.getElementsByClassName('js-slider-promo-full'),
                sliderArray = [];

            let flick;

            if (slider.length === 0) return;

            const options = {
                cellAlign: 'center',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                bgLazyLoad: 2
            };

            Array.prototype.forEach.call(slider, (node) => {
                flick = new Flickity(node, options);
                sliderArray.push(node);
            });

        },

        sliderCards__ready() {
            const slider = document.getElementsByClassName('js-slider-cards'),
                prev = document.getElementsByClassName('js-slider-cards-previous'),
                next = document.getElementsByClassName('js-slider-cards-next'),
                sliderArray = [];

            let flick;

            if (slider.length === 0) return;

            const options = {
                prevNextButtons: false,
                pageDots: true,
                wrapAround: true,
                bgLazyLoad: 2
            };

            Array.prototype.forEach.call(slider, (node) => {
                flick = new Flickity(node, options);
                sliderArray.push(flick);
            });

            Array.prototype.forEach.call(sliderArray, (sliderNode) => {

                Array.prototype.forEach.call(prev, (buttonNode) => {
                    buttonNode.addEventListener('click', () => {
                        sliderNode.previous();
                    })
                });

                Array.prototype.forEach.call(next, (buttonNode) => {
                    buttonNode.addEventListener('click', () => {
                        sliderNode.next();
                    })
                });
            });
        },

        eventsGallery__ready() {
            const slider = document.getElementsByClassName('js-slider-events-gallery'),
                prev = document.getElementsByClassName('js-slider-events-gallery-previous'),
                next = document.getElementsByClassName('js-slider-events-gallery-next'),
                sliderArray = [];

            let flick;

            if (slider.length === 0) return;

            const options = {
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                draggable: slider[0].getAttribute('data-scroll') === 'true',
                bgLazyLoad: 3,
                cellAlign: 'left'
            };

            Array.prototype.forEach.call(slider, (node) => {
                flick = new Flickity(node, options);
                sliderArray.push(flick);
            });

            Array.prototype.forEach.call(sliderArray, (sliderNode) => {

                Array.prototype.forEach.call(prev, (buttonNode) => {
                    buttonNode.addEventListener('click', () => {
                        sliderNode.previous();
                    })
                });

                Array.prototype.forEach.call(next, (buttonNode) => {
                    buttonNode.addEventListener('click', () => {
                        sliderNode.next();
                    })
                });
            });
        },

        popup__ready() {

            let popups = document.querySelectorAll('.js-popup'),
                popup_pageload = document.querySelectorAll('.js-popup-pageload'),
                popup_close = document.querySelectorAll('.js-popup-close'),
                popup_button = document.querySelectorAll('.js-popup-button');

            if (!Cookies.get('js-popupshown')) {
                popup_pageload && Array.prototype.forEach.call(popup_pageload, (pageload) => {
                    Util.removeClass(pageload, 'is-hidden');
                });
            }

            popup_close && Array.prototype.forEach.call(popup_close, (button) => {
                Util.addEventListener(button, ['click'], () => {
                    Util.addClass(popups, 'is-hidden');
                    Cookies.set('js-popupshown', true);
                });
            });

            popup_button && Array.prototype.forEach.call(popup_button, (button) => {
                Util.addEventListener(button, ['click'], () => {
                    let popup_id = button.getAttribute('data-popup');

                    Util.addClass(document.querySelector('.js-popup[data-popup="' + popup_id + '"]'), 'is-hidden');

                });
            });

        },

        youtube__ready: function () {

            var self = this;

            self.createScript = function () {

                var tag = document.createElement('script'),
                    firstScriptTag;

                tag.src = "https://www.youtube.com/iframe_api";

                firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                self.setPlayer();

            };

            self.ready = function () {

                $('.js-youtube-play').on('click', function () {

                    var $id = $(this).attr('data-youtube-video-id');
                    $('.js-youtube-video-image[data-youtube-video-id="' + $id + '"]').removeClass('is-active');
                    self.player[$id].playVideo();
                    $('.js-youtube-stop').addClass('is-active');
                    $('.js-video-wrap').addClass('is-active');

                });

                $('.js-youtube-stop').on('click', function () {
                    var $id = $(this).attr('data-youtube-video-id');
                    $('.js-youtube-video-image[data-youtube-video-id="' + $id + '"]').addClass('is-active');
                    self.player[$id].stopVideo();
                    $('.js-youtube-stop').removeClass('is-active');
                    $('.js-video-wrap').removeClass('is-active');
                });

            }

            self.setPlayer = function () {

                window.onYouTubeIframeAPIReady = function () {

                    self.player = {};

                    $('.js-youtube[data-youtube-video-id]').each(function () {

                        self.player[$(this).data('youtube-video-id')] = new YT.Player($(this)[0], {

                            videoId: $(this).data('youtube-video-id'),

                            playerVars: {

                                autoplay: 0,
                                controls: 0,
                                loop: 1,
                                modestbranding: 1,
                                playlist: $(this).data('youtube-video-id'),
                                playsinline: 1,
                                rel: 0,
                                showinfo: 0

                            },

                            events: {

                                'onReady': self.ready

                            }

                        });

                    });

                };

            };

            self.createScript();

        },

        scrollTo__ready: function () {

            this.init = () => {
                this.cache();
                this.bindEvents();
                this.checkUrl();
            }

            this.cache = () => {

                this.trigger = [...document.getElementsByClassName('js-scroll')];

            };

            this.bindEvents = () => {

                this.trigger.forEach((el) => {
                    el.addEventListener('click', this.handleClick)
                })

            };

            this.checkUrl = () => {

                const hash = window.location.hash;

                if (hash === '#signup-form') {

                    this.scroll(hash);

                }

            }

            this.handleClick = (e) => {

                if (window.location.pathname === '/') {

                    if (e) e.preventDefault();

                    this.scroll(this.getTarget(e));

                }

            }

            this.scroll = (e) => {

                const target = e; //this.getTarget(e);
                const middleOfScreen = window.innerHeight / 2;

                if (!target) return;

                $('html, body').animate({ 'scrollTop': $(target).offset().top - middleOfScreen }, 500);

            };

            this.getTarget = (e) => {
                const href = e.target.href;
                return href.slice(href.indexOf('#'));
            }

            window.addEventListener('load', this.init);

        }

    };


    window.propCore = new Init(propFuncs);

})(window);



// WEBPACK FOOTER //
// ./httpdocs/grandclassics/themes/wppt/assets/src/js/index.js